function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.6 4.80001H10.6C9.99999 4.80001 9.49999 5.30001 9.49999 5.90001V8.50001H5.99999H5.89999V2.00001C5.89999 1.50001 5.49999 1.10001 4.99999 1.10001H2.19999C1.69999 1.10001 1.29999 1.50001 1.29999 2.00001V29C1.29999 29.5 1.69999 29.9 2.19999 29.9H5.09999C5.59999 29.9 5.99999 29.5 5.99999 29V22.5H6.09999H9.49999V25.1C9.49999 25.7 9.99999 26.2 10.6 26.2H28.7C29.3 26.2 29.8 25.7 29.8 25.1V5.90001C29.7 5.30001 29.2 4.80001 28.6 4.80001ZM5.09999 29H2.19999V2.00001H5.09999V29ZM5.99999 9.40001H9.39999V11.4H5.99999V9.40001ZM5.89999 18.8V12.3H5.99999H9.39999V18.8H5.99999C5.99999 18.8 5.99999 18.8 5.89999 18.8ZM5.99999 21.6V19.6H9.39999V21.6H5.99999ZM28.8 25.1C28.8 25.2 28.7 25.3 28.6 25.3H10.6C10.5 25.3 10.4 25.2 10.4 25.1V21.6V19.6V11.4V9.40001V5.90001C10.4 5.80001 10.5 5.70001 10.6 5.70001H28.7C28.8 5.70001 28.9 5.80001 28.9 5.90001V25.1H28.8Z",
  fill: "#1C33C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.1 12.1C20.6 11.8 20 11.6 19 11.6H17.5C17.4 11.6 17.3 11.7 17.3 11.8V15.8C17.3 15.9 17.4 16 17.5 16H19.3C20.3 16 20.9 15.8 21.3 15.4C21.7 15 21.8 14.4 21.8 13.7C21.8 13 21.6 12.4 21.1 12.1ZM21 15.2C20.7 15.5 20.2 15.7 19.4 15.7H17.8V12H19C19.8 12 20.5 12.1 20.8 12.4C21.2 12.7 21.3 13.1 21.3 13.7C21.4 14.4 21.2 14.9 21 15.2Z",
  fill: "#1C33C8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.2 10.4C22.3 9.70002 20.9 9.30002 19 9.30002H14.8C14.7 9.30002 14.6 9.40002 14.6 9.50002V21.5C14.6 21.6 14.7 21.7 14.8 21.7H17.5C17.6 21.7 17.7 21.6 17.7 21.5V18.4H19.1C20.9 18.4 22.3 18 23.2 17.3C24.1 16.6 24.6 15.4 24.6 13.9C24.6 12.4 24.1 11.2 23.2 10.4ZM22.9 17C22.1 17.7 20.8 18 19.1 18H17.5C17.4 18 17.3 18.1 17.3 18.2V21.3H15V9.70002H19C20.8 9.70002 22.1 10 22.9 10.7C23.7 11.4 24.1 12.4 24.1 13.8C24.1 15.3 23.7 16.3 22.9 17Z",
  fill: "#1C33C8"
});

var SvgParking = function SvgParking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgParking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parking.5826f326.svg";
export { ForwardRef as ReactComponent };